import { StoryStatus, StoryType } from 'services/api/stories';

// Phase E Cycle 4 — values sourced from the canonical BE enums.
export const STORIES_STATUS_DRAFT = StoryStatus.Draft;
export const STORIES_STATUS_PUBLISHED = StoryStatus.Published;
export const STORIES_STATUS_ARCHIVED = StoryStatus.Archived;

export const STORIES_TYPE_PATIENT = StoryType.Patient;
export const STORIES_TYPE_DOCTOR = StoryType.Doctor;
export const STORIES_TYPE_BOTH = StoryType.Both;

export const STORIES_STATUSES = {
  [StoryStatus.Draft]: 'draft',
  [StoryStatus.Published]: 'published',
  [StoryStatus.Archived]: 'archived'
} as const satisfies Record<StoryStatus, string>;

export const STORIES_TYPES = {
  [StoryType.Patient]: 'patient',
  [StoryType.Doctor]: 'doctor',
  [StoryType.Both]: 'both'
} as const satisfies Record<StoryType, string>;

export const STORIES_TYPES_ARRAY = [
  {
    value: STORIES_TYPE_PATIENT,
    label: STORIES_TYPES[STORIES_TYPE_PATIENT]
  },
  {
    value: STORIES_TYPE_DOCTOR,
    label: STORIES_TYPES[STORIES_TYPE_DOCTOR]
  },
  {
    value: STORIES_TYPE_BOTH,
    label: STORIES_TYPES[STORIES_TYPE_BOTH]
  }
];

export const STORIES_STATUSES_ARRAY = [
  {
    value: STORIES_STATUS_DRAFT,
    label: STORIES_STATUSES[STORIES_STATUS_DRAFT]
  },
  {
    value: STORIES_STATUS_PUBLISHED,
    label: STORIES_STATUSES[STORIES_STATUS_PUBLISHED]
  },
  {
    value: STORIES_STATUS_ARCHIVED,
    label: STORIES_STATUSES[STORIES_STATUS_ARCHIVED]
  }
];
